module.exports = __webpack_public_path__ + "img/fig14.654e6182.jpg";